import { getSpaceSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy modules-list URL. The program home now lists modules, so redirect there.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/modules/')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getSpaceSlugPathQueryOptions(params.id));
    throw redirect({ to: '/programs/$programSlug', params: { programSlug: path.programSlug }, replace: true });
  },
});
